import React from 'react';
import { Progress, List, theme } from 'antd';
import { useTranslation } from 'react-i18next';

import { EPButton } from '@/components';
import { BucketCard, BucketHeader, BucketContent } from './styled';
import { ModelSpecsMissingProps } from './StationReadinessScore.utils';

const ModelSpecsMissing: React.FC<ModelSpecsMissingProps> = ({
  percentage,
  totalComponents,
  missingComponents,
  specs = [],
  onAddModelSpec,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  const handleAddSpec = (specId: string) => {
    if (onAddModelSpec) {
      onAddModelSpec(specId);
    }
  };

  return (
    <BucketCard>
      <BucketHeader>
        <div className="bucket-title">
          <div className="title-text">
            {t('Model specs missing')} ({missingComponents}/{totalComponents} {t('comps')})
          </div>
        </div>
        <div className="bucket-progress">
          <div className="percentage-text">{percentage}%</div>
          <Progress
            type="circle"
            percent={percentage}
            size={20}
            strokeWidth={12}
            strokeLinecap="square"
            showInfo={false}
            strokeColor={token.colorWhite}
            trailColor={token.colorFillSecondary}
          />
        </div>
      </BucketHeader>

      <BucketContent>
        <List
          itemLayout="vertical"
          dataSource={specs}
          split={false}
          renderItem={(spec) => (
            <List.Item key={spec.id} className="spec-item">
              <div className="item-content">
                <div className="text-wrapper">
                  <div className="item-title">{spec.name}</div>
                  <div className="item-description">{t(spec.description)}</div>
                </div>
                <div className="item-actions">
                  <EPButton
                    type="link"
                    size="small"
                    onClick={() => handleAddSpec(spec.id)}
                    loading={isLoading}
                    className="action-link"
                  >
                    {t('Add model spec')}
                  </EPButton>
                </div>
              </div>
            </List.Item>
          )}
        />
      </BucketContent>
    </BucketCard>
  );
};

export default ModelSpecsMissing;
